export default function DocumentAddendumDirective() {
  return {
    template: require('./document-addendum.html'),
    scope: {
      policyDocumentId: '=',
      canEdit: '=',
      canDelete: '=',
      addendum: '=',
    },
    controller: 'DocumentAddendumController',
    controllerAs: 'documentAddendumVM',
    bindToController: true,
    replace: true
  };
}
